import { render, staticRenderFns } from "./Numbering.yaml?vue&type=template&id=2e2ed91e&component"
import script from "./Numbering.yaml?vue&type=script&lang=ts&component"
export * from "./Numbering.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports